<template>
  <div class="col md-4 offre-service-item" v-on:click="open()">
    <i :class="icon"></i><br>
    <h3>{{ title }}</h3>
    <h4 v-if="optional">({{ $t('generics.optional') }})</h4>
    <p class="cardcontent">{{ content }}</p>
    <b-button v-if="link" :to="link" variant="success">{{ $t('generics.discover_button', {"name": title}) }} >
    </b-button>
  </div>
</template>

<script>
export default {
  props: ["icon", "title", "content", "link", "optional"],

  methods: {
    open() {
      this.$router.push(this.link);
    }
  }
}
</script>

<style scoped>
button {
  margin-bottom: 10px
}

h4 {
  margin-top: -31px;
  margin-bottom: 35px;
}

.offre-service-item {
  cursor: pointer;
  min-height: 520px;
}

.cardcontent {
  min-height: 210px;
}


@media screen and (min-width: 1400px) {
  .offre-service-item {
    min-height: 440px;
  }

  .cardcontent {
    min-height: 180px;
  }
}

@media screen and (min-width: 1800px) {
  .offre-service-item {
    min-height: 420px;
  }

  .cardcontent {
    min-height: 150px;
  }
}


@media screen and (max-width: 1150px) {
  .md-4 {
    width: 100%
  }

  .offre-service-item {
    min-height: unset;
  }

  .cardcontent {
    min-height: unset;
  }

}
</style>